import { USER_TYPE } from "../constants";
import { QUICK_FILTERS } from "../constants/Filters";

import type { UUID } from "utils";

import type { UserFilters } from "../models/Filters";

export type FilterParams = {
  active?: boolean;
  owner?: boolean;
  customer?: UUID[];
  voltEmployee?: boolean;
};

export function prepareFilterParams(
  filters?: Partial<UserFilters>
): FilterParams {
  const params: FilterParams = {};
  const hasActiveFilter = filters?.quickFilters?.includes(QUICK_FILTERS.ACTIVE);
  const hasInactiveFilter = filters?.quickFilters?.includes(
    QUICK_FILTERS.INACTIVE
  );

  if (filters?.type && filters.type.length > 0) {
    const hasOwner = filters.type.includes(USER_TYPE.OWNER);
    const hasStandardUser = filters.type.includes(USER_TYPE.STANDARD_USER);
    const hasVoltAdmin = filters.type.includes(USER_TYPE.VOLT_ADMIN);

    if (!(hasOwner && hasStandardUser && hasVoltAdmin)) {
      if (hasVoltAdmin) {
        params["voltEmployee"] = true;
      }

      if (hasOwner && !hasStandardUser) {
        params["owner"] = true;
      }

      if (hasStandardUser && !hasVoltAdmin) {
        params["voltEmployee"] = false;
      }

      if (hasStandardUser && !hasOwner) {
        params["owner"] = false;
      }
    }
  }

  if (hasActiveFilter && !hasInactiveFilter) {
    params["active"] = true;
  }

  if (hasInactiveFilter && !hasActiveFilter) {
    params["active"] = false;
  }

  if (Array.isArray(filters?.customerId) && filters?.customerId.length > 0) {
    params["customer"] = filters.customerId;
  }

  return params;
}
